export default class StorageBase implements IStorage {
	private impl: IStorageImplementation;
	[name: string]: any;
	length: number;

	constructor(impl: IStorageImplementation) {
		this.impl = impl;
	}

	clear(): void {
		throw new Error('Method not implemented.');
	}
	key(index: number): string | null {
		throw new Error('Method not implemented.');
	}

	setItem(key: string, value: Record<string, any>): void {
		this.impl.setItem(key, value);
	}

	getItem(key: string): Record<string, any> | null {
		return this.impl.getItem(key);
	}

	removeItem(key: string): void {
		this.impl.removeItem(key);
	}
}
